import { actorQueries } from "@-/dev.improve.haniverse.database.schemas.actor.query";
import { useActorTableChangeVersion } from "@-/dev.improve.haniverse.lib.database.change.actor";
import { createUseQueryOptions } from "@-/dev.improve.haniverse.lib.query-options";
import { getPendingCompletedSlideKeys } from "#pending-completed-slide-keys";

export function useGetCompletedSlideKeysQueryKey() {
  const completedSlidesQueryOptions = actorQueries(
    import.meta.location,
  ).userSlide.findMany.useQueryOptions({});
  const withTableChangeVersion = useActorTableChangeVersion("userSlide", {});

  return () =>
    withTableChangeVersion(["completedSlideKeys", { completedSlidesQueryOptions }] as const);
}

export const [useCompletedSlideKeysQueryOptions, completedSlideKeysQueryFn] = createUseQueryOptions(
  useGetCompletedSlideKeysQueryKey,
  async ({ client, queryKey: [_, { completedSlidesQueryOptions }] }) => {
    // Soft-delete filter is injected by the wrapped `actorDb` query proxy. A live row is not
    // enough: favoriting an unseen slide creates one with no `completedAt`, and an undone
    // completion keeps a favorited row — neither has been completed.
    const slides = await client.fetchQuery(completedSlidesQueryOptions);
    return new Set([
      ...slides.flatMap((slide) => (slide.completedAt === null ? [] : [slide.key])),
      ...getPendingCompletedSlideKeys(),
    ]);
  },
);
